import * as React from "react";

function SvgSortDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.89 12.9"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M23.45.42a1.38 1.38 0 010 2l-10.46 10a1.46 1.46 0 01-1.06.51 1.49 1.49 0 01-1-.42L.44 2.44a1.34 1.34 0 01-.44-1 1.34 1.34 0 01.44-1A1.49 1.49 0 011.49 0H22.4a1.49 1.49 0 011.05.42z" />
    </svg>
  );
}

const MemoSvgSortDown = React.memo(SvgSortDown);
export default MemoSvgSortDown;
